import FotaReducer from "./FotaReducer.js";
/**
 * Creates an initializer and provider creator for Api
 */
export default {
  id: 'molten.FotaReducer',
  sort: 0,
  init: molten => {},
  createReducers: molten => {
    return {
      fota: FotaReducer
    };
  }
};